/* eslint-disable @typescript-eslint/no-explicit-any */
import { cva } from 'class-variance-authority'
import { forwardRef, useImperativeHandle, useRef } from 'react'
import { cn } from '~/lib/utils'

const activeColours = cva('', {
  variants: {
    colour: {
      chartreuse: 'bg-char-40',
      'ink-blue': 'bg-blue-d-60',
      'mid-blue': 'bg-blue-m-60',
      'light-blue': 'bg-blue-l-60',
      'light-pink': 'bg-pink-60',
      'light-aqua': 'bg-green-60',
      'light-purple': 'bg-purple-60',
      'light-orange': 'bg-orange-60',
      'light-grey': 'bg-grey-m',
      white: 'bg-grey-l'
    }
  },
  defaultVariants: {
    colour: 'white'
  }
})

const MenuIcon = forwardRef(
  (
    props: {
      fill: string
      secondaryfill: any
      title: string
      width: number
      height: number
      isActive: boolean
      activeColour?: AllBackgroundColours
    },
    ref
  ) => {
    const fill = props.fill || 'currentColor'
    const secondaryfill = props.secondaryfill || fill
    const title = props.title || 'menu icon'
    const width = props.width || 24
    const height = props.height || 24
    const colour = props.activeColour

    const groupRef = useRef<SVGGElement>(null)

    useImperativeHandle(ref, () => ({
      toggleAnimation: () => {
        if (groupRef.current) {
          groupRef.current.classList.toggle('menu')
        }
      }
    }))

    return (
      <div
        className={cn(
          props.isActive ? activeColours({ colour }) : 'bg-black/0',
          'group p-2xs transition-colors duration-300 ease-in-out'
        )}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          height={height}
          width={width}
          viewBox='0 0 48 48'
        >
          <title>{title}</title>
          <g
            strokeLinecap='square'
            strokeWidth='3'
            fill={secondaryfill}
            stroke={secondaryfill}
            strokeLinejoin='miter'
            strokeMiterlimit='10'
          >
            <g ref={groupRef} className='js-nc-int-icon nc-int-menu'>
              <line
                x1='24'
                y1='10'
                x2='46'
                y2='10'
                stroke={fill === 'white' ? '#ffffff' : '#0e1647'}
                className={cn(
                  props.isActive ? 'translate-x-[-22px]' : '',
                  'first-child transition-transform duration-300 group-hover:translate-x-[-22px]'
                )}
              ></line>
              <line
                x1='2'
                y1='24'
                x2='46'
                y2='24'
                stroke={fill === 'white' ? '#ffffff' : '#0e1647'}
              ></line>
              <line
                x1='2'
                y1='38'
                x2='24'
                y2='38'
                stroke={fill === 'white' ? '#ffffff' : '#0e1647'}
                className={cn(
                  props.isActive ? 'translate-x-[22px]' : '',
                  'last-child transition-transform duration-300 group-hover:translate-x-[22px]'
                )}
              ></line>
            </g>
          </g>
        </svg>
      </div>
    )
  }
)

MenuIcon.displayName = 'MenuIcon'

export default MenuIcon
